export default __webpack_public_path__ + "static/media/brochure_3.07495320.jpg";